module.exports = __webpack_public_path__ + "img/2023big10.5f359c63.png";